"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _jsSha = _interopRequireDefault(require("js-sha256"));

var _multihashes = _interopRequireDefault(require("multihashes"));

var _ipldDagCbor = _interopRequireDefault(require("ipld-dag-cbor"));

var ENC_BLOCK_SIZE = 24;

var pad = function pad(val) {
  var blockSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ENC_BLOCK_SIZE;
  var blockDiff = (blockSize - val.length % blockSize) % blockSize;
  return "".concat(val).concat('\0'.repeat(blockDiff));
};

var unpad = function unpad(padded) {
  return padded.replace(/\0+$/, '');
};

var sha256Multihash = function sha256Multihash(str) {
  return _multihashes["default"].encode(Buffer.from((0, _jsSha["default"])(str)), 'sha2-256').toString('hex');
};

var tmpData;
var fakeIpfs = {
  dag: {
    put: function put(data, opts) {
      tmpData = data;
      return _ipldDagCbor["default"].util.cid(_ipldDagCbor["default"].util.serialize(data, opts));
    },
    get: function get() {
      return {
        value: tmpData
      };
    }
  },
  add: function add() {
    return 'empty';
  } // used in _initMuport in 3box-js 3id, but muport fingerprint not needed here

};

var fakeEthProvider = function fakeEthProvider(wallet) {
  return {
    send: function send(request, callback) {
      if (request.method !== 'personal_sign') {
        callback(new Error('only supports personal_sign'));
      } else {
        var message = request.params[0];

        if (message.startsWith('0x')) {
          message = Buffer.from(message.slice(2), 'hex').toString('utf8');
        }

        callback(null, {
          result: wallet.signMessage(message)
        });
      }
    }
  };
};

module.exports = {
  pad: pad,
  unpad: unpad,
  sha256: _jsSha["default"],
  sha256Multihash: sha256Multihash,
  fakeIpfs: fakeIpfs,
  fakeEthProvider: fakeEthProvider
};